import React from "react";

import Button from "@mui/joy/Button";
import CardContent from "@mui/joy/CardContent";
import Card from "@mui/joy/Card";
import {CircularProgress, Stack} from "@mui/joy";

// components
import BaseApi from "../../utils/BaseApi";
import CommonStepper from "../Common/CommonStepper";
import CommonForm from "../Common/CommonForm";
import {deleteArrayItemByKeyValue, setArrayKey,} from "../../utils/misc";


class LeadCreateInner extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeStep: 0,
            formFields: [],
            lead: {},
        };
        this.steps = [
            {
                order: 0,
                title: 'Компания',
            },
            // {
            //     order: 1,
            //     title: 'Контактная информация',
            // },
            {
                order: 2,
                title: 'Описание',
            },
        ]
    }

    async componentDidMount() {
        let formFields = await this.retrieveFields(
            'lead/create_form',
                [
                    'title',
                    'account',
                    'inn',
                    'account_title',
                    'url',
                ]
        )
        formFields = setArrayKey(
            formFields,
            'name',
            'submitButton',
            'label',
            'Далее',
        )
        this.setState(
            {
                formFields: formFields
            }
        )
    }

    async retrieveFields(url, fields){
        const api = new BaseApi();
        let response = await api.get(
            url,
            {
                fields: fields?JSON.stringify(fields):null
            }
        );
        return response.data
    }

    updateLeadObj(lead, formData){
        let formDataObj = Object.fromEntries(
            formData.entries()
        );
        for (let k of Object.keys(formDataObj)){
            lead[k] = formDataObj[k]
        }
        return lead
    }

    async processStep0(form) {
        let lead = this.updateLeadObj(
            this.state.lead,
            form.state.formData,
        );
        let formFields = await this.retrieveFields(
            'lead/create_form',
                [
                    'contact',
                    'last_name',
                    'first_name',
                    'patronymic',
                    'role',
                    'phone',
                    'email',
                ]
        );
        if (this.state.lead.account){
            const api = new BaseApi();
            let url = `contact/`;
            let response = await api.get(
                url,
                {
                    entity: 'Account',
                    entity_id: this.state.lead.account.id,
                    page_size: 10000,
                }
            );
            formFields = setArrayKey(
                formFields,
                'name',
                'contact',
                'options',
                response.data.results.map((each) => (
                    {'value': each.id, 'label': `${each.first_name} ${each.last_name} - ${each.role}`}
                ))
            )
        }
        else {
            formFields = deleteArrayItemByKeyValue(
                formFields,
                'name',
                'contact'
            );
        }
        formFields = setArrayKey(
            formFields,
            'name',
            'submitButton',
            'label',
            'Далее',
        )
        this.setState(
            {
                activeStep: 1,
                lead: lead,
                formFields: formFields,
            }
        );
        await this.processStep1(null)
    }

    async processStep1(form) {
        if(form){
            this.updateLeadObj(
                this.state.lead,
                form.state.formData,
            );
        }

        let formFields = await this.retrieveFields(
            'lead/create_form',
                [
                    'desc',
                    'source',
                ]
        );
        formFields = setArrayKey(
            formFields,
            'name',
            'submitButton',
            'label',
            'Далее',
        )
        this.setState(
            {
                activeStep: 2,
                formFields: formFields,
            }
        );
    }

    async processStep2(form) {
        const api = new BaseApi();
        let url = `lead/`;
        let lead = this.updateLeadObj(
            this.state.lead,
            form.state.formData,
        );
        let response = await api.post(
            url,
            lead
        );
        if (response.status === 201) {
            await this.props.callBack();
        }
    }

    async setStep(order) {
        let formData = new FormData();
        let formFake = {
            state: {
                formData: formData
            }
        }
        if (order === 0){
            await this.componentDidMount()
        }
        else {
            await this['processStep'+(order-1)](formFake)
        }
        this.setState(
            {activeStep: order}
        )
    }

    render(){
        if (!this.state.formFields) {
            return (<CircularProgress/>)
        }
        if (this.state.activeStep === 0){
            return(
                <Stack
                    spacing={2}
                >
                    <CommonStepper
                        steps={this.steps}
                        activeStep={this.state.activeStep}
                        callBack={this.setStep.bind(this)}
                    />
                    <CommonForm
                        key={`new-lead-form-step-${this.state.activeStep}`}
                        fields={this.state.formFields}
                        processForm={this.processStep0.bind(this)}
                    />
                </Stack>
            )
        }
        else if (this.state.activeStep === 1){
            return(
                <Stack
                    spacing={2}
                >
                    <CommonStepper
                        steps={this.steps}
                        activeStep={this.state.activeStep}
                        callBack={this.setStep.bind(this)}
                    />
                    <CommonForm
                        key={`new-lead-form-step-${this.state.activeStep}`}
                        fields={this.state.formFields}
                        processForm={this.processStep1.bind(this)}
                    />
                </Stack>
            )
        }
        else if (this.state.activeStep === 2){
            return(
                <Stack
                    spacing={2}
                >
                    <CommonStepper
                        steps={this.steps}
                        activeStep={this.state.activeStep}
                        callBack={this.setStep.bind(this)}
                    />
                    <CommonForm
                        key={`new-lead-form-step-${this.state.activeStep}`}
                        fields={this.state.formFields}
                        processForm={this.processStep2.bind(this)}
                    />
                </Stack>
            )
        }
    }
}

export default LeadCreateInner
